define.alias("checkout/components/payment/stripe-payment-element/index", "calendar/components/payment/stripe-payment-element/index");